module.exports = __webpack_public_path__ + "static/media/breakfast-hotcakes-kitchen-svgrepo-com.d13583cd.svg";